export const GLOBAL_TOASTER_NOTIFICATION_TIMEOUT = 60000;

export const EMPLOYER_MENU_ITEMS = [
  {
    key: 'show_dashboard',
    display_name: 'Dashboard',
    img: '/static-ec/nav-icons/events.svg',
  },
  {
    key: 'show_hiring_events',
    display_name: 'Hiring Events',
    img: '/static-ec/nav-icons/events.svg',
  },
  {
    key: 'show_user_roles_permissions',
    display_name: 'User Roles & Permissions',
    img: '/static-ec/nav-icons/permissions.svg',
  },
  {
    key: 'show_hubs',
    display_name: 'Hubs',
    img: '/static-ec/nav-icons/permissions.svg',
  },
  {
    key: 'show_settings',
    display_name: 'Settings',
    img: '/static-ec/nav-icons/permissions.svg',
  },
  {
    key: 'show_manage_budgets',
    display_name: 'Manage Budgets',
    img: '/static-ec/nav-icons/events.svg',
  },
  {
    key: 'show_job_reporting',
    display_name: 'Job Reporting',
    img: '/static-ec/nav-icons/events.svg',
  },
];

export const SPACING = {
  SMALL: 8,
  MEDIUM: 16,
  LARGE: 24,
};

export const STATIC_ARRAY = [1, 2, 3];

export const MONTHS_BY_NUMBER = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const EXPECTED_ROUTE_KEYS = {
  SHOW_DASHBOARD: 'show_dashboard',
  SHOW_HUBS: 'show_hubs',
  SHOW_HIRING_EVENTS: 'show_hiring_events',
  SHOW_BILLING: 'show_billing',
  SHOW_SETTINGS: 'show_settings',
  SHOW_USER_ROLES_PERMISSIONS: 'show_user_roles_permissions',
  SHOW_MANAGE_BUDGETS: 'show_manage_budgets',
  SHOW_JOB_REPORTING: 'show_job_reporting',
};

export const EXPECTED_ROUTES = Object.keys(EXPECTED_ROUTE_KEYS).map(key => EXPECTED_ROUTE_KEYS[key]);

export const EXPECTED_ROUTES_TITLES = {
  [EXPECTED_ROUTE_KEYS.SHOW_DASHBOARD]: 'Dashboard',
  [EXPECTED_ROUTE_KEYS.SHOW_HIRING_EVENTS]: 'Hiring Events',
  [EXPECTED_ROUTE_KEYS.SHOW_USER_ROLES_PERMISSIONS]: 'User Roles & Permissions',
  [EXPECTED_ROUTE_KEYS.SHOW_HUBS]: 'Hubs',
  [EXPECTED_ROUTE_KEYS.SHOW_SETTINGS]: 'Settings',
  [EXPECTED_ROUTE_KEYS.SHOW_BILLING]: 'Billing',
  [EXPECTED_ROUTE_KEYS.SHOW_MANAGE_BUDGETS]: 'Manage Budgets',
  [EXPECTED_ROUTE_KEYS.SHOW_JOB_REPORTING]: 'Job Reporting',
};

export const SIZE_FONT_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const STATUS_TYPES = [
  'Draft',
  'Confirmed',
  'Cancelled',
  'Ended',
  'Change Submitted',
];

export const LOCATIONS = [
  'Texas',
  'New York',
  'New Jersey',
  'Florida',
  'Georgia',
  'Ohio',
  'Alabama',
];

export const EMPLOYER_ROLES = {
  JOBCASE_EMPLOYER_ADMIN: 'JobcaseEmployerAdmin',
  EMPLOYER_MODULE_MANAGER: 'EmployerModuleManager',
  HIRING_EVENT_MANAGER: 'HiringEventManager',
  COMPANY_HUB_MANAGER: 'CompanyHubManager',
  SETTINGS_MANAGER: 'SettingsManager',
  DASHBOARD_MANAGER: 'DashboardManager',
  ATS_CREDENTIALS_MANAGER: 'AtsCredentialsManager',
  USER_ADMINISTRATOR: 'UserAdministrator',
  JOBS_MANAGER: 'JobManager',
  BILLING_MANAGER: 'BillingManager',
  JOB_CAMPAIGNS_MANAGER: 'OptimizationCampaignManager',
  BUDGET_MANAGER: 'BudgetManager',
  JOB_REPORTING: 'JobFeedReportManager',
};

export const DEPRECATED_EMPLOYER_ROLES = {
  GLOBAL: 'Global',
  ADMINISTRATOR: 'Administrator',
  JOB_MANAGEMENT: 'JobManagement',
  CANDIDATE_REVIEWER: 'CandidateReviewer',
};

export const EMPLOYER_ROLE_ACCESS_LEVELS = {
  READ: 'Read',
  WRITE: 'Write',
  ADMIN_READ: 'AdminRead',
  ADMIN_WRITE: 'AdminWrite',
};

export const REPORTING_EVENT_LOCATIONS = {
  EVENT_OPTIONS: 'Event Options',
  INDEX_HIRING_EVENTS: 'Index',
  EVENT_DETAILS: 'Event Details',
  JOB_DETAILS: 'Job Details',
  OTHER_DETAILS: 'Other Details',
};

export const MIN_AUTOSUGGEST_PREFIX = 3;

export default {
  REPORTING_EVENT_LOCATIONS,
  GLOBAL_TOASTER_NOTIFICATION_TIMEOUT,
  EMPLOYER_MENU_ITEMS,
  SPACING,
  STATIC_ARRAY,
  EXPECTED_ROUTES,
  EXPECTED_ROUTES_TITLES,
  SIZE_FONT_VARIANTS,
  STATUS_TYPES,
  LOCATIONS,
  MONTHS_BY_NUMBER,
  EMPLOYER_ROLES,
  DEPRECATED_EMPLOYER_ROLES,
  EMPLOYER_ROLE_ACCESS_LEVELS,
  MIN_AUTOSUGGEST_PREFIX,
};
